import React from 'react';

export const CaretDown: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width || '1em'} height={height || '1em'} viewBox="0 0 128 128">
        <path fill={color || 'currentColor'} d="M13.6,32.66,62.19,81.25a2.56,2.56,0,0,0,3.62,0L114.4,32.66a2.56,2.56,0,0,1,3.65,0l3.36,3.49a2.56,2.56,0,0,1,0,3.58L65.81,95.34a2.58,2.58,0,0,1-3.62,0L6.62,39.77a2.56,2.56,0,0,1,0-3.58L10,32.7A2.56,2.56,0,0,1,13.6,32.66Z" />
    </svg>
);
